import { render } from "./BovineChildBirth.vue?vue&type=template&id=10dac9ee&scoped=true"
import script from "./BovineChildBirth.vue?vue&type=script&lang=js"
export * from "./BovineChildBirth.vue?vue&type=script&lang=js"

import "./BovineChildBirth.vue?vue&type=style&index=0&id=10dac9ee&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10dac9ee"]])

export default __exports__